import { render, staticRenderFns } from "./MessagesObjectiveDetails.vue?vue&type=template&id=16f3340f&scoped=true&"
import script from "./MessagesObjectiveDetails.vue?vue&type=script&lang=js&"
export * from "./MessagesObjectiveDetails.vue?vue&type=script&lang=js&"
import style0 from "./MessagesObjectiveDetails.vue?vue&type=style&index=0&id=16f3340f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3340f",
  null
  
)

export default component.exports